import { ref, useTemplateRef } from 'vue'
import type UserRegistrationModal from '@/components/userManagement/UserRegistrationModal.vue'
import type UserRegistrationSuccessDialog from '@/components/userManagement/UserRegistrationSuccessDialog.vue'
import type UserDeleteConfirmDialog from '@/components/userManagement/UserDeleteConfirmDialog.vue'
import { setLoadingView } from '@/features/miiaFw/utils/miiaFwUtils'
import { useUserManagement } from './useUserManagement'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

export const useUserPartsCombination = () => {
  const userRegistrationModal =
    useTemplateRef<InstanceType<typeof UserRegistrationModal>>('userRegistrationModal')
  const userRegistrationSuccessDialog = useTemplateRef<
    InstanceType<typeof UserRegistrationSuccessDialog>
  >('userRegistrationSuccessDialog')
  const userDeleteConfirmDialog =
    useTemplateRef<InstanceType<typeof UserDeleteConfirmDialog>>('userDeleteConfirmDialog')
  const { fetchUserInfoForGovAdmin } = useUserManagement()
  const checkedItems = ref<string[]>([])

  /**
   * 新規作成ボタン押下時に呼ばれる
   */
  const createUser = async () => {
    // 新規ユーザー登録モーダル画面を表示する
    const result = await userRegistrationModal.value?.openModal()
    if (!result) {
      return
    }
    // 新規登録成功ダイアログを表示する
    await userRegistrationSuccessDialog.value?.openDialog()
    // 新規登録成功後に、自治体管理者用のユーザー情報を再取得する
    try {
      setLoadingView(true)
      await fetchUserInfoForGovAdmin()
    } catch (e) {
      throw GlobalError.chainError(e, ERROR_CODES._811201_FETCH_USER_ERROR)
    } finally {
      setLoadingView(false)
    }
  }

  /**
   * 削除ボタン押下時に呼ばれる
   */
  const deleteUser = async () => {
    // ユーザー削除確認ダイアログ画面を表示する
    const result = await userDeleteConfirmDialog.value?.openDialog()
    if (!result) {
      return
    }
    // ユーザー削除処理は成功しているので、チェックをリセットする
    checkedItems.value = []
    // ユーザー削除処理成功後に、自治体管理者用のユーザー情報を再取得する
    try {
      setLoadingView(true)
      await fetchUserInfoForGovAdmin()
      checkedItems.value = []
    } catch (e) {
      throw GlobalError.chainError(e, ERROR_CODES._811201_FETCH_USER_ERROR)
    } finally {
      setLoadingView(false)
    }
  }
  return { checkedItems, createUser, deleteUser }
}
